
import React, { useEffect } from 'react';
import "../Assets/styles/Services.css"
import ServiceBanShape from "../Assets/Resources/service-ban-shape.png"
import Serviceoneimg from "../Assets/Resources/service-one-1.png"
import RightArrow from "../Assets/Resources/service-right-arrow.svg"
import KeyBenefitsImg from "../Assets/Resources/adobe-benefits-img.png"
import KeyBenefitsImg2 from "../Assets/Resources/adobe-benefits-img-2.png"
import KeyBenefitsImg3 from "../Assets/Resources/adobe-benefits-img-3.png"
import KeyBenefitsImg4 from "../Assets/Resources/adobe-benefits-img-4.png"
import KeyBenefitsImg5 from "../Assets/Resources/adobe-benefits-img-5.png"
import AiDataImage from "../Assets/Resources/ai-data-img.png"
import Logo from "../Assets/Resources/banner-logo.svg";
import Slider from "react-slick";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitType from 'split-type'
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceStar from "../Assets/Resources/service-star.svg"
import AllPageLoader from '../Components/AllPageLoader';

const DigitalAcceleration = () => {

    const serSettings = {
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200, // For screens smaller than 1200px
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992, // For screens smaller than 992px
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768, // For screens smaller than 768px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576, // For screens smaller than 576px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };




    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);



    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);







    return (
        <>
            <AllPageLoader />
            <section className='service-hero-section'>
                <div className="container-fluid common-btn">
                    <div className="row">
                        <div className="banner-content">
                            <h1 className='ban-title-animation'>Prophecy <br />Technologies</h1>
                            <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="500">Chart Your Course, Unleash Digital Force!

                            </h6>
                            <p data-aos="fade-down" data-aos-duration="2000" data-aos-delay="700">we empower your business to navigate the digital landscape with confidence and precision. Our digital acceleration services harness cutting-edge technology and innovative strategies to drive growth and efficiency. Chart your course with us, and unleash the full potential of your digital transformation!
                            </p>
                            <a href="/contact">
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Talk with Our Experts</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="service-hero-shape">
                    <img src={ServiceBanShape} alt="" />
                </div>
            </section>


            <section className='service-section-one  sec-padding smarteerTomorrow service-sec'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="content large-title">
                                <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">Transform Your Business for the Future With</h6>
                                <h1 className='mini-title-animation'>Our Digital <br />Acceleration <br />Services</h1>
                                <p className='para-animation'>we empower businesses to redefine their future with cutting-edge digital acceleration solutions. By delivering comprehensive business restructuring strategies and intelligent automation technologies, we enable enterprises to navigate market complexities with ease. Our tailored services ensure organizations achieve increased agility, informed decision-making, and sustainable competitive advantages. Whether you are looking to streamline operations or enhance operational efficiency, our innovative solutions are designed to meet your unique challenges head-on.</p>
                                <p className='para-animation'>Our expertise also extends to advanced data analytics solutions, unlocking the true potential of your business data. By leveraging these insights, organizations can optimize processes, enhance data utilization, and craft data-driven growth strategies. With intelligent automation, we help reduce manual workloads and improve productivity by implementing smart workflows that drive cost reductions and elevate service delivery. Partner with Prophecy Technologies to embrace digital transformation and gain the strategic edge needed to thrive in an ever-evolving business landscape.</p>
                                <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Get Started on Your Transformation</button>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-left" data-aos-duration="2000" data-aos-delay="300">
                                <img src={AiDataImage} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6>Our Suite of </h6>
                                    <h1 className='mini-title-animation'>Digital <br />Acceleration <br />Services
                                    </h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>Discover our comprehensive suite of digital acceleration services designed to transform your business, enhance efficiency, and drive sustainable growth in the digital landscape.
                        </p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Business Restructuring
                                                </h6>
                                                <p>Revitalize your organization with tailored restructuring solutions that address market challenges and enhance operational efficiency. We deliver strategies designed to increase agility, optimize resources, and secure long-term competitive advantages.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. Data Analytics Solutions</h6>
                                                <p>Unlock the power of data with our advanced analytics services, tailored to deliver actionable insights. Optimize decision-making, improve processes, and drive growth through strategic data utilization.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Intelligent Automation
                                                </h6>
                                                <p>Streamline operations with intelligent automation technologies that reduce manual workloads and enhance productivity. Achieve cost efficiency, automated workflows, and seamless service delivery.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Web Development Solutions</h6>
                                                <p>Transform your digital presence with innovative web development solutions that blend functionality with stunning design. Build scalable, user-centric platforms to elevate customer experiences and drive business growth.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">How Can Digital Acceleration </h6>
                                <h1 className='mini-title-animation'>Transform <br />Your Business <br />Operations?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>we redefine the way businesses operate in the digital age, offering transformative solutions that drive efficiency, innovation, and growth. Here’s how digital acceleration can revolutionize your business:
                    </p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Enhanced Operational Efficiency</h6>
                                            <p>Digital acceleration streamlines processes through intelligent automation and advanced tools, minimizing manual tasks and reducing errors. This improves productivity while cutting operational costs.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Informed Decision-Making
                                            </h6>
                                            <p>With our advanced data analytics solutions, businesses gain actionable insights from data. These insights empower leaders to make strategic decisions based on real-time information</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Improved Customer Experiences</h6>
                                            <p>Digital tools enable businesses to deliver personalized and seamless customer interactions. By leveraging automation and web development, your brand can elevate customer satisfaction and loyalty.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Agility in Market Adaptation</h6>
                                            <p>In today’s dynamic markets, being adaptable is crucial. Digital acceleration equips your business with the tools to pivot quickly in response to industry changes or challenges.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Sustainable Growth and Innovation</h6>
                                            <p>Through business restructuring and innovative technology integration, we help you build a scalable and future-proof foundation, ensuring long-term success in a competitive landscape.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Schedule a Free Consultation</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">Why Should Businesses Prioritize</h6>
                                    <h1 className='mini-title-animation'>Digital <br />Acceleration <br />Today?</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg3} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>In an era of rapid technological advancement, digital acceleration is no longer optional—it is essential for businesses aiming to thrive. At Prophecy Technologies, we help organizations harness the power of digital transformation to stay ahead of the curve. Here's why prioritizing digital acceleration is critical:</p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Stay Competitive in a Fast-Paced Market
                                                </h6>
                                                <p>With industries evolving at an unprecedented pace, digital acceleration ensures your business remains agile and responsive to change. By integrating advanced tools and technologies, you gain a competitive edge.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. Enhance Operational Efficiency</h6>
                                                <p>Streamlined processes powered by intelligent automation reduce costs and increase productivity. Digital solutions free your team from repetitive tasks, allowing them to focus on high-value activities.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Meet Evolving Customer Expectations
                                                </h6>
                                                <p>Customers expect seamless, personalized experiences. Digital acceleration enables businesses to deliver intuitive services and build long-term relationships through innovative platforms.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Leverage Data for Strategic Insights</h6>
                                                <p>Data is a key asset in today’s business landscape. Advanced analytics helps you uncover trends, optimize processes, and make informed decisions that drive growth.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Future-Proof Your Business</h6>
                                                <p>Investing in digital acceleration prepares your organization for tomorrow’s challenges. With scalable solutions and a focus on innovation, you ensure sustained growth and resilience.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                                <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Contact Us To Get Started
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">What Makes Prophecy Technologies the Perfect</h6>
                                <h1 className='mini-title-animation'>Partner for <br />Digital <br />Growth?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>we combine expertise, innovation, and a customer-centric approach to drive digital transformation. Here’s why we are the ideal partner for your digital growth journey:
                    </p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Comprehensive Digital Solutions
                                            </h6>
                                            <p>From business restructuring to intelligent automation and data analytics, we provide end-to-end services tailored to your unique needs. Our solutions are designed to enhance agility, optimize operations, and drive sustainable growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Industry Expertise and Innovation
                                            </h6>
                                            <p>Our team brings extensive experience across various industries, ensuring we understand your challenges and goals. We stay ahead of technological trends, offering innovative solutions that keep you competitive.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Tailored Strategies for Maximum Impact</h6>
                                            <p>Every business is unique, which is why we design custom strategies that align with your objectives. Our solutions address specific pain points, enabling impactful and measurable results.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Commitment to Client Success
                                            </h6>
                                            <p>We prioritize long-term partnerships by focusing on your success. Our dedicated support ensures seamless implementation, regular optimization, and ongoing guidance throughout your digital journey.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Scalable and Future-Proof Solutions
                                            </h6>
                                            <p>We develop scalable solutions that grow with your business. By embracing emerging technologies, we prepare your organization for future challenges and opportunities.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Schedule a Free Consultation</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default DigitalAcceleration